<template>
  <div class="vuestic-widget" :class="{'no-header': !headerText}">
    <div class="vuestic-widget-header" v-if="headerText">{{headerText}}</div>
    <div class="vuestic-widget-body" v-if="hasSlotData">

      <div v-show="contentLoad">
        <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
          <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
            <component
              :animation-duration="1000"
              :is="'SpringSpinner'"
              :color="'#4AE387'"
              :size="80"
            >
            </component>
          </div>
        </div>
      </div>

      <div v-show="!contentLoad">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import * as spinners from 'epic-spinners'

export default {
  name: 'vuestic-widget',
  components: {
    ...spinners
  },
  props: {
      headerText: {
        type: String,
        required: false
      },
      contentLoad: {
        type: Boolean,
        required: false,
        default: function () {
          return false;
        }
      }
  },
  computed: {
    hasSlotData () {
      return this.$slots.default
    },
  },
}
</script>

<style lang="scss">
.vuestic-widget {
  background: $widget-bg;
  box-shadow: $widget-box-shadow;
  margin-bottom: $widget-mb;
  padding: 0;

  &.no-header {
    .vuestic-widget-body {
    }
  }

  &.larger-padding {
    .vuestic-widget-body {
      padding: $widget-larger-padding;
    }
  }

  &.no-h-padding {
    .vuestic-widget-body {
      padding-left: 0;
      padding-right: 0;
    }
  }

  &.no-v-padding {
    .vuestic-widget-body {
      padding-top: 0;
      padding-bottom: 0;
    }
  }

  &.brand-info {
    background-color: $brand-info;
    color: $white;
    box-shadow: $widget-info-shadow;
  }

  &.brand-danger {
    background-color: $brand-danger;
    color: $white;
    box-shadow: $widget-danger-shadow;
  }

  &.info-widget {
    border-top: $info-widget-border;

    &.brand-info {
      border-top-color: $brand-info;
    }

    &.brand-danger {
      border-top-color: $brand-danger;
    }
  }

  .vuestic-widget-body {
    padding: $widget-padding;
  }

  .vuestic-widget-header {
    height: $widget-header-height;
    padding: 0 $widget-padding;
    border-bottom: $widget-header-border;
    font-size: 1.375rem;
    font-weight: 600;
    display: flex;
    align-items: center;
  }
}
</style>
